import {BaseComponent} from '../../../../base.component';
import {Component, OnInit} from '@angular/core';
import {SegmentationService} from '../../../../../services/segmentation/segmentation.service';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-entities-attribute-association',
  templateUrl: './entities-attribute-association.component.html',
  styleUrls: ['./entities-attribute-association.component.css']
})
export class EntitiesAttributeAssociationComponent extends BaseComponent implements OnInit{
  fullAssocList = [];
  attributeObj = [];
  eid = '';
  attrList = [];
  entities = [];
  limit = 9999;
  offset = 0;
  show = false;
  constructor (private segmentService: SegmentationService) {
    super();
  }
  ngOnInit() {
    this.getAllEntityAttributeAssociationList();
    this.getEntities();
    this.getList();
  }

  //  ################  Get Full List of Entities and Attribute Association  ######  //

  getAllEntityAttributeAssociationList() {
    this.segmentService.getAllEntityAttributeAssoc().subscribe(data => {

      if (data.status) {
        this.fullAssocList = data.data;
      } else  {
        this.fullAssocList = [];
      }
    }, error => {
    //  console.log(error);
    });
  }

  //  ################  Get List of Entities  #################  //

  getEntities() {
    this.ngxSpinnerService.show();
    this.segmentService.getEntity(this.limit, this.offset, 'createdon', 'desc').subscribe(data => {
      if (data.status) {
        this.entities = data.data.rows;
      } else  {
        this.entities = [];
      }
      this.ngxSpinnerService.hide();
    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });
  }

  //  ###############  Get Attributes List  #######  //

  getList(){
    this.segmentService.getSegementAttributeList(this.limit, this.offset,  'createdon', 'desc').subscribe(data => {
      if (data.status){
        this.attrList = data.data.rows;
      } else {
        this.attrList = [];
      }
      this.ngxSpinnerService.hide();
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error);
    });
  }

  //  ##############  Fetch Associated Attributes with Entity  ###########  //

  getAssociatedAttribute(id){
    this.attributeObj = [];
    this.show = false;
    this.fullAssocList = [];
    if (id === '') {
      this.getAllEntityAttributeAssociationList();
      return;
    }

    this.ngxSpinnerService.show();
    this.segmentService.getAssociatedAttributesForEntities(id).subscribe(data => {
      if (data.status) {
        let arr = data.data;
        if (arr.length > 0){
          for (let obj of data.data){
            let val = this.attrList.filter(elem => elem.field_id === obj.field_id);
            this.attributeObj.push(val[0]);
          }
        }
      } else  {
        this.toastrService.error(data.message);
      }
      this.show = true;
      this.ngxSpinnerService.hide();
    }, error => {
    //  console.log(error);
      this.ngxSpinnerService.hide();
    });
  }

  //  ##############  Edit Association  ###################  //


  editAssociation(){
    let URL = '/corporate/add-entities-attribute-association' ;


    this.router.navigate([URL], { queryParams: {'assocId': this.eid}});

  }

  //  ############# Edit Association (Selecting Entity ID from Full List ########  //

  editAssociationById(id){
    let URL = '/corporate/add-entities-attribute-association';


    this.router.navigate([URL], { queryParams: {'assocId': id}});

  }
}
